import { FilteredOutageHeroProps } from "components/OutageHero";
import { statusMapper } from "src/utils/statusMapper";

type StatusProps = {
  cause?: string | undefined | null;
  status?: string | undefined | null;
} & FilteredOutageHeroProps;

export const setStatus = ({ cause, status, ...outageProps }: StatusProps) => {
  if (cause === 'Onderhoud') {
    return statusMapper<'monteur onderweg' | 'monteur ter plaatse' | 'opgelost'>({
      currentStatus: status ?? '',
      variants: [
        {
          status: 'monteur onderweg',
          label: outageProps.maintenancePhaseOneLabel?.toString() ?? '',
          text: outageProps.maintenancePhaseOneText?.toString() ?? '',
        },
        {
          status: 'monteur ter plaatse',
          label: outageProps.maintenancePhaseTwoLabel?.toString() ?? '',
          text: outageProps.maintenancePhaseTwoText?.toString() ?? '',
        },
        {
          status: 'opgelost',
          label: outageProps.maintenancePhaseThreeLabel?.toString() ?? '',
          text: outageProps.maintenancePhaseThreeText?.toString() ?? '',
        },
      ],
      fallback: {
        status: 'monteur onderweg',
        label: outageProps.maintenancePhaseOneLabel?.toString() ?? '',
        text: outageProps.maintenancePhaseOneText?.toString() ?? '',
      },
    });
  }

  return statusMapper<'monteur onderweg' | 'monteur ter plaatse' | 'opgelost'>({
    currentStatus: status ?? '',
    variants: [
      {
        status: 'monteur onderweg',
        label: outageProps.outagePhaseOneLabel?.toString() ?? '',
        text: outageProps.outagePhaseOneText?.toString() ?? '',
      },
      {
        status: 'monteur ter plaatse',
        label: outageProps.outagePhaseTwoLabel?.toString() ?? '',
        text: outageProps.outagePhaseTwoText?.toString() ?? '',
      },
      {
        status: 'opgelost',
        label: outageProps.outagePhaseThreeLabel?.toString() ?? '',
        text: outageProps.outagePhaseThreeText?.toString() ?? '',
      },
    ],
    fallback: {
      status: 'monteur onderweg',
      label: outageProps.outagePhaseOneLabel?.toString() ?? '',
      text: outageProps.outagePhaseOneText?.toString() ?? '',
    },
  });
};